import type { CalculationResult } from '~/pages/IncomeCalculator/types';

import BreakdownContainer from '../BreakdownContainer';
import lang from '../language.json';
import SingleLineValue from '../styles/SingleLineValue';
import Continuance from './Continuance';

type IRABankBreakdownProps = {
  selectedResult?: CalculationResult;
  onNewWindow?: (...args: any[]) => any;
  hideAccordion?: boolean;
};

export default function IRABankBreakdown({
  selectedResult,
  hideAccordion = false,
  onNewWindow,
}: Readonly<IRABankBreakdownProps>) {
  return (
    <BreakdownContainer
      header={lang.HEADERS[selectedResult.calculatorTypeId]}
      hideAccordion={hideAccordion}
      onNewWindow={onNewWindow}
    >
      <SingleLineValue
        title={lang.MONTHLY_INCOME}
        value={selectedResult.calculationAmount}
        isCurrency
      />
      <Continuance selectedResult={selectedResult} />
    </BreakdownContainer>
  );
}
